import {instance, onErrorFunction, onSuccessFunction} from "../../../config/axios-cnf";

export const apiGetCheckTicket = (subjectId,bc,callback,error)=>{
    instance.get("/api/v2/enigoo/"+subjectId+"/ticket/check/"+bc)
        .then((response) => callback(onSuccessFunction(response.data)))
        .catch((err) => error(onErrorFunction(err)));
}

export const apiGetTicketImage = (subjectId, filename, callback, error) => {
    instance.get("/api/v2/enigoo/"+subjectId+"/ticket/image/"+encodeURIComponent(filename))
        .then((response) => callback(onSuccessFunction(response.data)))
        .catch((err) => error(onErrorFunction(err)));
}
